module.exports = __webpack_public_path__ + "static/media/file_find2.25fe37fd.ico";